// US-004: Handle unsupported browser or missing WebRTC

import { useTranslation } from "@/clientWeb/i18n/LanguageContext"

export function UnsupportedBrowser({ reason = "webrtc" }: { reason?: "browser" | "webrtc" }) {
  const t = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-vc-surface px-4 text-vc-text">
      <div className="w-full max-w-md rounded-3xl bg-card/5 p-10 text-center ring-1 ring-white/10">
        <div className="mx-auto mb-6 grid h-20 w-20 place-items-center rounded-full bg-red-500/10 ring-1 ring-red-500/20">
          <svg className="h-10 w-10 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
              d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-white">
          {reason === "webrtc" ? t("extraFiles.webrtcNotAvailable") : t("extraFiles.browserNotSupported")}
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-white/60">
          {reason === "webrtc"
            ? t("extraFiles.webrtcNotAvailableDesc")
            : t("extraFiles.browserNotSupportedDesc")}
        </p>

        <div className="mt-8 grid grid-cols-2 gap-3 text-xs text-white/50">
          {["Chrome", "Edge", "Firefox", "Safari"].map((b) => (
            <div key={b} className="flex items-center gap-2 rounded-xl bg-card/5 px-3 py-2 ring-1 ring-white/10">
              <div className="h-2 w-2 rounded-full bg-green-400" />
              {b}
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-8 w-full rounded-xl bg-indigo-500 py-3 text-sm font-semibold text-white transition hover:bg-indigo-400"
        >
          {t("extraFiles.tryAgain")}
        </button>
      </div>
    </div>
  )
}
